// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2nHxG","assignButton":"CreateEditEquipmentSchedule_assignButton__3tGm0"};